import { render, staticRenderFns } from "./ServeCountForDept.vue?vue&type=template&id=71c544b5&scoped=true&"
import script from "./ServeCountForDept.vue?vue&type=script&lang=js&"
export * from "./ServeCountForDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c544b5",
  null
  
)

export default component.exports